import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addIntrestrate } from "../../actions/IntrestrateActions";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';

class IntrestrateAddModal extends React.Component {

    constructor() {
        super();
        this.state = {
            rateofintrest: "",
            currency_id: "",
            currencyList:[],
            errors: {},
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.currencyList) {
            this.setState({
                currencyList: nextProps.currencyList
            })
        }
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
    }
    onChange = e => {
        if (e.target.id === 'currency_id') {
            this.setState({ currency_id: e.target.value });
        }
        if (e.target.id === 'intrestrateName') {
            this.setState({ rateofintrest: e.target.value });
        }
    };

    onIntrestrateAdd = e => {
        e.preventDefault();
        const newIntrestrate = {
            rateofintrest: this.state.rateofintrest,
            currency_id: this.state.currency_id
        };
        this.props.addIntrestrate(newIntrestrate, this.props.history);
    };
    showHtml = () => {
        const html = []
         this.state.currencyList.map(function (value, i) {
              html.push(
                     <>  
                         <option value={value.id}>{value.short_name}</option>
                     </>
                 );
             
     })
     return html;
     }
    render() {
        const { errors } = this.state;
        return (
            <div>
                <div className="modal fade" id="add-user-modal" data-reset="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Add Intrest Rate</h4>
                                <button type="button" className="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div className="modal-body">
                                <form noValidate onSubmit={this.onIntrestrateAdd} id="add-user">
                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="currency_id">Currency Name</label>
                                        </div>
                                        <div className="col-md-9">
                                        <select className={classnames("form-control", {
                                                invalid: errors.currency_id
                                                })} id="currency_id" error={errors.currency_id} onChange={this.onChange} aria-label="Default select example">
                                                <option selected>Select Currency</option>
                                                 {this.showHtml()}
                                            </select>
                                           <span className="text-danger">{errors.currency_id}</span>
                                        </div>
                                    </div>
                                         <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="name">Intrest Rate %</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.rateofintrest}
                                                id="intrestrateName"
                                                type="number"
                                                error={errors.rateofintrest}
                                                className={classnames("form-control", {
                                                    invalid: errors.rateofintrest
                                                })}/>
                                            <span className="text-danger">{errors.rateofintrest}</span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button
                                    form="add-user"
                                    type="submit"
                                    className="btn btn-primary">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

IntrestrateAddModal.propTypes = {
    addIntrestrate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { addIntrestrate }
)(withRouter(IntrestrateAddModal));
